import { useTranslation } from 'react-i18next';
import { asDueCategory } from '../assistantFormat';
import type { DueCategory } from '../assistantTypes';

const DUE_STYLE: Record<DueCategory, string> = {
  Day: 'bg-red-50 text-red-700',
  Week: 'bg-amber-50 text-amber-700',
  Month: 'bg-slate-100 text-slate-600',
  None: 'bg-slate-100 text-slate-500',
};

export function DueTag({ due }: { due: string | null | undefined }) {
  const { t } = useTranslation('planning');
  const category = asDueCategory(due);
  return (
    <span className={`px-1.5 py-0.5 rounded text-[10.5px] font-medium whitespace-nowrap ${DUE_STYLE[category]}`}>
      {t(`assistant.due.${category}`)}
    </span>
  );
}
